export default "__VITE_ASSET__3c0cf987__"